module.exports = __webpack_public_path__ + "static/media/hypeschool_bg.d89ed099.svg";